import {
  put, call, takeLatest, all,
} from 'redux-saga/effects';
import NetworkService from 'services/networkService';
import SystemSettingActionType from 'actions/systemSetting/systemSettingActionType';
import { changeLoadingState, setErrorMessage, changeEndedStatus } from 'app/settings/slices';
import { saveSystemSettings } from 'actions/systemSetting/systemSettingActionCreator';
import { AppConstants } from 'constants/index';
import { getError } from 'utils/helpers';
import { isJSON } from 'utils/utils';

function* getSystemSettings() {
  try {
    yield put(changeLoadingState(true));
    const { ReportingAdmin, SystemSettings } = AppConstants.api;
    const { data } = yield call(NetworkService.makeAPIGetRequest, [ReportingAdmin, SystemSettings]);
    yield put(changeLoadingState(false));
    yield put(saveSystemSettings(data));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* editSystemSettings({ payload }) {
  try {
    const { data } = payload;
    const options = {
      data,
    };
    yield put(changeLoadingState(true));
    const { ReportingAdmin, SystemSettings } = AppConstants.api;
    yield call(NetworkService.makeAPIPutRequest, [ReportingAdmin, SystemSettings], options);
    yield put(changeLoadingState(false));
    yield put(changeEndedStatus(true));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

export default function* systemSettingSaga() {
  yield all([takeLatest(SystemSettingActionType.GET_SYSTEM_SETTINGS, getSystemSettings), takeLatest(SystemSettingActionType.EDIT_SYSTEM_SETTINGS, editSystemSettings)]);
}
